import type { UndoAction } from '@/lib/history/types/undo-action'
import type { HistoryDirection } from '@/lib/history/types/history-direction'
import type { HistoryPersistencePlan } from '@/lib/history/types/history-persistence-plan'

export function createEmptyPersistencePlan(
  actionType: UndoAction['type'],
  direction: HistoryDirection
): HistoryPersistencePlan {
  return {
    historyTxnId: undefined,
    historyActionType: actionType,
    historyDirection: direction,
    batchElementIds: [],
    shapeMarkEditedIds: [],
    shapeUpserts: [],
    shapeDeleteIds: [],
    shapeResequenceIds: [],
    syncActiveFromShapeSelection: false,
  }
}

export function pushUnique(target: string[], id: string) {
  if (!target.includes(id)) target.push(id)
}

export function mergePersistencePlans(
  target: HistoryPersistencePlan,
  source: HistoryPersistencePlan
): HistoryPersistencePlan {
  target.historyTxnId = target.historyTxnId ?? source.historyTxnId
  target.historyActionType = source.historyActionType ?? target.historyActionType
  target.historyDirection = source.historyDirection ?? target.historyDirection

  for (const id of source.shapeMarkEditedIds) pushUnique(target.shapeMarkEditedIds, id)
  target.shapeUpserts.push(...source.shapeUpserts)
  target.shapeDeleteIds.push(...source.shapeDeleteIds)
  for (const id of source.shapeResequenceIds) pushUnique(target.shapeResequenceIds, id)
  if (source.batchElementIds && source.batchElementIds.length > 0) {
    target.batchElementIds = target.batchElementIds ?? []
    for (const id of source.batchElementIds) {
      if (!target.batchElementIds.includes(id)) target.batchElementIds.push(id)
    }
  }

  target.syncActiveFromShapeSelection =
    target.syncActiveFromShapeSelection || source.syncActiveFromShapeSelection

  if (source.linkedTextChainsUpsert) {
    target.linkedTextChainsUpsert = source.linkedTextChainsUpsert
  }

  if (source.spreadBackgroundsRestore) {
    target.spreadBackgroundsRestore = source.spreadBackgroundsRestore
  }

  return target
}
